import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { AttributesService } from '../../../core/services/attributes.service';
import { Size } from '../../../shared/models/Attribute';

@Component({
  selector: 'app-size-admin',
  standalone: true,
  imports: [CommonModule, FormsModule, TableModule, ButtonModule, DialogModule, InputTextModule, ToastModule, ConfirmDialogModule],
  providers: [MessageService, ConfirmationService],
  templateUrl: './size-admin.html',
  styleUrls: ['./size-admin.css']
})
export class SizesAdminComponent implements OnInit {
  sizes: Size[] = [];
  size: Partial<Size> = {};
  dialog: boolean = false;
  submitted: boolean = false;

  constructor(
    private service: AttributesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() { this.load(); }

  load() { this.service.getSizes().subscribe(data => {this.sizes = data; this.cdr.detectChanges();}); }

  openNew() {
    this.size = { isActive: true };
    this.submitted = false;
    this.dialog = true;
  }

  edit(item: Size) {
    this.size = { ...item };
    this.dialog = true;
  }

  save() {
    this.submitted = true;
    if (this.size.name?.trim()) {
      const req = this.size.id
        ? this.service.updateSize(this.size.id, this.size as Size)
        : this.service.createSize(this.size as Size);

      req.subscribe(() => {
        this.messageService.add({severity:'success', summary:'Éxito', detail:'Talla guardada'});
        this.load();
        this.dialog = false;
      });
    }
  }

  toggle(item: Size) {
    this.confirmationService.confirm({
      message: `¿${item.isActive ? 'Desactivar' : 'Activar'} la talla ${item.name}?`,
      header: 'Confirmar Estado',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.service.toggleSize(item.id).subscribe(() => this.load());
      }
    });
  }
}
